// @flow
import authStore from "common/services/user/authStore"

const _store = {} // eslint-disable-line no-underscore-dangle

export default {
  add(id: number, token: string) {
    // called both simple_token and auth_token
    _store[id] = token
  },
  get(id: number) {
    return authStore.token ? { token: authStore.token } : { simple_token: _store[id] }
  },
  getAuth() {
    return authStore.token
  },
  getSimple(id: number) {
    return _store[id]
  },
  remove(id: number) {
    if (id) {
      _store[id] = null
    }
    authStore.kwAuthToken = null
    authStore.token = null
  },
}
